module.exports = {"emails":{"info":"info@moowle.com","support":"moowle@moowle.com"},"phones":{"info":"12345678"}}


//////////////////
// WEBPACK FOOTER
// ./src/config/moowleContacts.json
// module id = OkL0
// module chunks = 1